
import { ReportFormat } from "../../Enums/ReportFormat";
import Modal from "../common/Modal/Modal";
import Button from "../Button/Button";

type ReportFormatModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (format: ReportFormat) => void;
};

const ReportFormatModal = ({ isOpen, onClose, onSelect }: ReportFormatModalProps) => {

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={"Formato do relatório"}>
      <div className="flex flex-col gap-3">
        <Button
          className="w-full py-2"
          onClick={() => onSelect(ReportFormat.Pdf)}
        >
          PDF
        </Button>
        <Button
          className="w-full py-2"
          onClick={() => onSelect(ReportFormat.Csv)}
        >
          CSV
        </Button>
      </div>
    </Modal>
  );
};

export default ReportFormatModal;
